import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {deleto, get, post, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";

// Create reconciliation
export function* createRequest() {
    yield takeEvery(actions.RECONCILIATION_CREATE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/reconciliations', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.RECONCILIATION_CREATE_SUCCESS,
                reconciliation: data.reconciliation,
            });
        }
        catch (error) {
            yield put({
                type: actions.RECONCILIATION_CREATE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createSuccess() {
    yield takeEvery(actions.RECONCILIATION_CREATE_SUCCESS, function* () {
        yield message.success(t`The bank account is reconciled.`);
    });
}
export function* createError() {
    yield takeEvery(actions.RECONCILIATION_CREATE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read reconciliations.
export function* readListRequest() {
    yield takeEvery(actions.RECONCILIATION_READ_LIST_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/reconciliations', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.RECONCILIATION_READ_LIST_SUCCESS,
                reconciliations: data.reconciliations,
            });
        }
        catch (error) {
            yield put({
                type: actions.RECONCILIATION_READ_LIST_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readListSuccess() {
    yield takeEvery(actions.RECONCILIATION_READ_LIST_SUCCESS, () => {});
}
export function* readListError() {
    yield takeEvery(actions.RECONCILIATION_READ_LIST_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read reconciliation.
export function* readRequest() {
    yield takeEvery(actions.RECONCILIATION_READ_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/reconciliations/${id}`, request, context);
            const data = yield response.data;

            yield put({
                type: actions.RECONCILIATION_READ_SUCCESS,
                reconciliation: data.reconciliation,
            });
        }
        catch (error) {
            yield put({
                type: actions.RECONCILIATION_READ_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readSuccess() {
    yield takeEvery(actions.RECONCILIATION_READ_SUCCESS, () => {});
}
export function* readError() {
    yield takeEvery(actions.RECONCILIATION_READ_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update reconciliation.
export function* updateRequest() {
    yield takeEvery(actions.RECONCILIATION_UPDATE_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(puto, `/reconciliations/${id}`, request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.RECONCILIATION_UPDATE_SUCCESS,
                reconciliation: data.reconciliation,
            });
        }
        catch (error) {
            yield put({
                type: actions.RECONCILIATION_UPDATE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateSuccess() {
    yield takeEvery(actions.RECONCILIATION_UPDATE_SUCCESS, function* () {
        yield message.success(t`The bank reconciliation is updated.`);
    });
}
export function* updateError() {
    yield takeEvery(actions.RECONCILIATION_UPDATE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete reconciliation.
export function* deleteRequest() {
    yield takeEvery(actions.RECONCILIATION_DELETE_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/reconciliations/${id}`, null, context);

            yield put({
                type: actions.RECONCILIATION_DELETE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.RECONCILIATION_DELETE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteSuccess() {
    yield takeEvery(actions.RECONCILIATION_DELETE_SUCCESS, function* () {
        yield message.success(t`The bank reconciliation is deleted.`);
    });
}
export function* deleteError() {
    yield takeEvery(actions.RECONCILIATION_DELETE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Create transaction
export function* createTransactionRequest() {
    yield takeEvery(actions.RECONCILIATION_CREATE_TRANSACTION_REQUEST, function* ({ txnType, request },
        context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            context.allow_intercept = true;
            const response = yield call(post, `/reconciliations/${txnType}s`, request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.RECONCILIATION_CREATE_TRANSACTION_SUCCESS,
                ledger: data.ledger,
            });
        }
        catch (error) {
            yield put({
                type: actions.RECONCILIATION_CREATE_TRANSACTION_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createTransactionSuccess() {
    yield takeEvery(actions.RECONCILIATION_CREATE_TRANSACTION_SUCCESS, function* () {
        yield message.success(t`The transaction is created.`);
    });
}
export function* createTransactionError() {
    yield takeEvery(actions.RECONCILIATION_CREATE_TRANSACTION_ERROR, function* ({ error }) {
        if (!error.canSuppress)
            yield message.error(error.message);
    });
}

// // Read unreconciled transactions
// export function* readTransactionsRequest() {
//   yield takeEvery(actions.RECONCILIATION_READ_TRANSACTIONS_REQUEST, function*({ request }) {
//     try {
//       yield put({ type: AppActions.APP_START_PULLING });
//       const response =yield call(get, '/reconciliations/transactions', request, context);
//       const data = yield response.data;

//       // OK
//       yield put({
//         type: actions.RECONCILIATION_READ_TRANSACTIONS_SUCCESS,
//         transactions: data.transactions,
//       });
//     }
//     catch (error) {
//       yield put({
//         type: actions.RECONCILIATION_READ_TRANSACTIONS_ERROR,
//         error,
//       });
//     }
//     finally {
//       yield put({ type: AppActions.APP_STOP_PULLING });
//     }
//   });
// }
// export function* readTransactionsSuccess() {
//   yield takeEvery(actions.RECONCILIATION_READ_TRANSACTIONS_SUCCESS, function*() {});
// }
// export function* readTransactionsError() {
//   yield takeEvery(actions.RECONCILIATION_READ_TRANSACTIONS_ERROR, function*({ error }) {
//     yield message.error(error.message);
//   });
// }

export default function* rootSaga() {
    yield all([
        fork(createRequest),
        fork(createSuccess),
        fork(createError),
        fork(readListRequest),
        fork(readListSuccess),
        fork(readListError),
        fork(readRequest),
        fork(readSuccess),
        fork(readError),
        fork(updateRequest),
        fork(updateSuccess),
        fork(updateError),
        fork(deleteRequest),
        fork(deleteSuccess),
        fork(deleteError),
        fork(createTransactionRequest),
        fork(createTransactionSuccess),
        fork(createTransactionError),
    // fork(readTransactionsRequest),
    // fork(readTransactionsSuccess),
    // fork(readTransactionsError),
    ]);
}
